import { render } from "./PageItem.vue?vue&type=template&id=0eba6797"
import script from "./PageItem.vue?vue&type=script&lang=js"
export * from "./PageItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/PageItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0eba6797"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0eba6797', __exports__)) {
    api.reload('0eba6797', __exports__)
  }
  
  module.hot.accept("./PageItem.vue?vue&type=template&id=0eba6797", () => {
    api.rerender('0eba6797', render)
  })

}


export default __exports__